import { isRecetteBuild, requireRecetteApiBase } from '@shared/constants/buildProfile';
import { resolveHttpsApiBase } from '@shared/utils/httpsApiUrl';

/** URL de base de nexxus-licensing-api (desktop). HTTPS hors localhost. */
export function getLicensingApiBase(): string {
  const fromEnv = import.meta.env.VITE_LICENSING_API_URL as string | undefined;
  if (isRecetteBuild()) return requireRecetteApiBase(fromEnv, 'VITE_LICENSING_API_URL');
  return resolveHttpsApiBase(fromEnv, 'https://api.nexxus.ga', Boolean(import.meta.env.DEV));
}

/** Plateforme release attendue par licensing-api. */
export function detectReleasePlatform(): 'win' | 'mac' | 'linux' {
  if (typeof navigator !== 'undefined') {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('mac')) return 'mac';
    if (ua.includes('linux') && !ua.includes('android')) return 'linux';
  }
  return 'win';
}

export function detectReleaseArchitecture(platform = detectReleasePlatform()): 'x64' | 'universal' {
  return platform === 'mac' ? 'universal' : 'x64';
}

export function latestReleaseUrl(
  platform = detectReleasePlatform(),
  architecture = detectReleaseArchitecture(platform),
  channel = 'stable',
): string {
  const base = getLicensingApiBase();
  const q = new URLSearchParams({ platform, architecture, channel });
  return `${base}/v1/releases/latest?${q.toString()}`;
}
